/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext } from 'react';
import { fromPairs, compact } from 'lodash';
export const CacheContext = createContext(undefined);
export const ResourceCacheProvider = ({ initialData, children, offline, rootResourceUrl }) => (React.createElement(CacheContext.Provider, { value: Object.assign(new Map(Object.entries(initialData)), { offline, rootResourceUrl }) }, children));
export const MockResourceCache = ({ root, mocks = [], children }) => {
    const mockData = fromPairs(compact([root, ...mocks]).map(({ value, q = value, resource }) => [resource.urlFromData(q), value]));
    return (React.createElement(ResourceCacheProvider, { offline: true, initialData: mockData, rootResourceUrl: root && root[0].urlFromData(root[1]) }, children));
};
//# sourceMappingURL=resource-cache.js.map